import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    login,
    logout,
    selectLogin
  } from '../features/login/loginSlice.js';
import './root.css';
import Login from '../Components/Login/Login.js';
import { useNavigate, useLocation, Outlet } from "react-router-dom";

export default function Root() {
    const isLogin = useSelector(selectLogin);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
      const token = localStorage.getItem('token');
      if (token && !isLogin) {
        dispatch(login());
      }
    }, [dispatch, isLogin]);

    const currentPath = location.pathname.replace('/', '') || 'progetti';
    const email = localStorage.getItem('email') || 'Dev User';

    const navItems = [
      { id: 'progetti', label: 'Progetti', icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
      )},
      { id: 'credenziali', label: 'Credenziali', icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
      )},
      { id: 'carico', label: 'Test di Carico', icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline></svg>
      )},
      { id: 'progetti-history', label: 'Progetti History', icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
      )},
      { id: 'dashboard', label: 'Dashboard', icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="9"></rect><rect x="14" y="3" width="7" height="5"></rect><rect x="14" y="12" width="7" height="9"></rect><rect x="3" y="16" width="7" height="5"></rect></svg>
      )},
      { id: 'iterazioni', label: 'Iterazioni Agile', icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect></svg>
      )},
    ];

    const handleNavigate = (path) => {
        navigate(`/${path}`);
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('email');
        dispatch(logout());
        navigate('/');
    };

    if (!isLogin) {
      return <Login />;
    }

    return (
      <div className="app-layout">
        <aside id="sidebar">
          <div className="sidebar-brand">
            <div className="brand-logo">R42</div>
            <div className="brand-info">
              <h3>Risposta42</h3>
              <span>Dev Console v0.1</span>
            </div>
          </div>

          <nav className="sidebar-nav">
            <div className="nav-section-title">NAVIGAZIONE PRINCIPALE</div>
            <ul>
              {navItems.map(item => {
                const isActive = currentPath === item.id || (currentPath === '' && item.id === 'progetti');
                return (
                  <li key={item.id}>
                    <button 
                      className={`link-nav ${isActive ? 'active' : ''}`} 
                      onClick={() => handleNavigate(item.id)}
                    >
                      <span className="nav-icon">{item.icon}</span>
                      <span className="nav-label">{item.label}</span>
                      {isActive && <span className="active-dot" />}
                    </button>
                  </li>
                );
              })}
            </ul>
          </nav>

          <div className="sidebar-footer">
            <div className="user-profile">
              <div className="avatar">{email.charAt(0).toUpperCase()}</div>
              <div className="user-details">
                <span className="user-name">{email}</span>
                <span className="user-role">Sviluppatore</span>
              </div>
            </div>
            <button className="btn-logout" onClick={handleLogout} title="Disconnetti">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
            </button>
          </div>
        </aside>

        <main id="detail">
          <header className="app-topbar">
            <div className="topbar-left">
              <span className="topbar-breadcrumb">Risposta42 / {navItems.find(i => i.id === currentPath)?.label || 'Progetti'}</span>
            </div>
            <div className="topbar-right">
              <span className="status-badge live">
                <span className="pulse-dot"></span> Backend Connected
              </span>
            </div>
          </header>

          <div className="content-container">
            <Outlet />
          </div>
        </main>
      </div>
    );
  }